/* ORZO, równa kolejność lokali 2026-10-17. Każdy lokal szuka rezerwacji, więc żaden nie stoi stale pierwszy:
   przy pierwszym wejściu gość dostaje losową kolejność, która zostaje z nim do końca wizyty (sessionStorage),
   żeby listy nie skakały między podstronami. Ta sama kolejność we wszystkich listach na stronie.
   Bez JS (i dla Google) zostaje kolejność z kolejnosc-lokali. Cofnięcie: usunąć linię orzo-rotacja w orzo-warstwy. */
(function () {
  var KEY = 'orzo.kolejka', order = null;
  try { order = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
  function kolor(el) {
    var v = el.getAttribute('data-venue') || el.getAttribute('data-nh') || el.getAttribute('data-s');
    if (!v) { var a = el.matches('a[href]') ? el : el.querySelector('[data-venue],[data-nh],a[href*="/restauracje/"]'); if (!a) return null;
      v = a.getAttribute('data-venue') || a.getAttribute('data-nh') || ((a.getAttribute('href') || '').match(/\/restauracje\/([a-z]+)/) || [])[1]; }
    return v ? v.split('-')[0] : null;
  }
  var lists = [['.nl', '.nl-c'], ['.nh-row', 'a'], ['#rezd .rezd-l', 'li'], ['.nd-lok ul', 'li'], ['.nf-lok ul', 'li'], ['.nlk-mg', '.nlk-m']];
  if (!order) {
    var seen = {}; order = [];
    document.querySelectorAll('.nf-lok li, #rezd .rezd-l li, .nd-lok li').forEach(function (li) { var k = kolor(li); if (k && !seen[k]) { seen[k] = 1; order.push(k); } });
    for (var i = order.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = order[i]; order[i] = order[j]; order[j] = t; }
    try { if (order.length) sessionStorage.setItem(KEY, JSON.stringify(order)); } catch (e) {}
  }
  if (!order.length) return;
  lists.forEach(function (l) {
    document.querySelectorAll(l[0]).forEach(function (box) {
      var items = [].filter.call(box.children, function (c) { return c.matches(l[1]); });
      if (items.length < 2) return;
      items.map(function (el) { var k = kolor(el), p = order.indexOf(k); return { el: el, p: p < 0 ? 99 : p }; })
        .sort(function (a, b) { return a.p - b.p; })
        .forEach(function (x) { box.appendChild(x.el); });
      box.scrollLeft = 0;
    });
  });
})();
